var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var ProcessService = /** @class */ (function (_super) {
            __extends(ProcessService, _super);
            function ProcessService($q, $http, $rootScope, growl, userActionService, modalService) {
                var _this = _super.call(this, $http) || this;
                _this.$q = $q;
                _this.$http = $http;
                _this.$rootScope = $rootScope;
                _this.growl = growl;
                _this.userActionService = userActionService;
                _this.modalService = modalService;
                _this.NO_VALUE_ID = "00000000-0000-0000-0000-000000000000";
                return _this;
            }
            ProcessService.prototype.getCachedProcess = function (processId) {
                if (this.lastProcess && this.lastProcess.id === processId) {
                    return this.lastProcess;
                }
                return null;
            };
            ProcessService.prototype.getProcessDto = function (processId) {
                var _this = this;
                var d = this.$q.defer();
                this.$http.get('./api/Process/' + processId)
                    .then(function (result) {
                    _this.lastProcess = result.data;
                    if (_this.lastProcess != null) {
                        d.resolve(_this.lastProcess);
                    }
                    else {
                        _this.growl.error("Could not find Process: " + processId, { ttl: 5000 });
                        d.reject();
                    }
                });
                return d.promise;
            };
            ProcessService.prototype.getProcessName = function (processId) {
                var d = this.$q.defer();
                this.$http.get('./api/Process/' + processId + "/ProcessName")
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ProcessService.prototype.runSystemAction = function (processId, systemActionId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' + processId + '/SystemAction/' + systemActionId, null).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessService.prototype.runProcessAction = function (processId, processActionId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' + processId + '/ProcessAction/' + processActionId, null).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessService.prototype.changeState = function (processId, stateCodeUniqueId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' + processId + '/ChangeState/' + stateCodeUniqueId, null).then(function (r) {
                    d.resolve(r.data);
                });
                return d.promise;
            };
            ProcessService.prototype.createNewProcess = function (processTypeId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' + processTypeId + '/Process', undefined)
                    .then(function (result) {
                    var createProcessDto = result.data;
                    d.resolve(createProcessDto);
                });
                return d.promise;
            };
            ProcessService.prototype.createNewProcessWithSubType = function (processTypeId, processSubType) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' + processTypeId + '/SubType/' + processSubType + '/Process', undefined)
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ProcessService.prototype.showProcessSubTypeModal = function (createProcessDto, successCallback, failureCallback) {
                var userSelection = {};
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/processSubTypeModal.html",
                    controller: "processSubTypeModalController",
                    size: 'lg',
                    inputs: {
                        createProcessDto: createProcessDto,
                        userSelection: userSelection
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        // Only true if not a cancel
                        if (result && result.cancel !== true && userSelection.subTypeSystemCodeUniqueId) {
                            if (successCallback)
                                successCallback((userSelection.subTypeSystemCodeUniqueId));
                        }
                        else {
                            if (failureCallback)
                                failureCallback();
                        }
                    });
                });
            };
            ProcessService.prototype.addReview = function (processId, reviewSetId, reviewUserId, dueDate, reviewType, assignedDate) {
                var d = this.$q.defer();
                var data = {
                    id: processId,
                    reviewSetId: reviewSetId,
                    reviewUserId: reviewUserId,
                    dueDate: dueDate,
                    assignedDate: assignedDate
                };
                if (reviewType) {
                    data.reviewTypeUniqueId = reviewType.uniqueIdentifier;
                }
                this.$http.post('./api/Process/AddReview', data)
                    .then(function (result) {
                    d.resolve(result.data);
                });
                return d.promise;
            };
            ProcessService.prototype.closeReview = function (processId, reviewSetId, reviewId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' +
                    processId +
                    "/ReviewSet/" +
                    reviewSetId +
                    "/Review/" +
                    reviewId +
                    '/Close', null)
                    .then(function (result) {
                    d.resolve(result);
                });
                return d.promise;
            };
            ProcessService.prototype.saveReviewComment = function (processId, reviewSetId, reviewId, comment) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' +
                    processId +
                    "/ReviewSet/" +
                    reviewSetId +
                    "/Review/" +
                    reviewId +
                    '/Comment', '"' + comment + '"')
                    .then(function () {
                    d.resolve();
                });
                return d.promise;
            };
            ProcessService.prototype.updateReviewDocuments = function (processId, reviewSetId, reviewId, documentIds) {
                return this.$http.post('./api/Process/' + processId + "/ReviewSet/" + reviewSetId + "/Review/" + reviewId + '/Documents', documentIds);
            };
            ProcessService.prototype.executeUserAction = function (processId, userActionId, processActionWorkflowBlockId) {
                var self = this;
                var params = {
                    processActionWorkflowBlockId: processActionWorkflowBlockId
                };
                this.handlerUrl = "api/Process/" + processId + "/ExecuteUserAction/" + userActionId;
                var promise = this.usePostHandler(params);
                promise.then(function (manageAppDto) { return self.displayDocumentsAndDownloads(manageAppDto); });
                return promise;
            };
            ProcessService.prototype.executeUserActionWithModel = function (processId, userActionId, model) {
                var self = this;
                var params = {
                    comment: model.comment,
                    documentIds: model.docIds,
                    effectiveDateString: model.effectiveDate ? model.effectiveDate.toUTCString() : undefined,
                    processActionWorkflowBlockId: model.processActionWorkflowBlockId
                };
                this.handlerUrl = "api/Process/" + processId + "/ExecuteUserActionWithModel/" + userActionId;
                //Randy - transient user action data preservation for validation error
                this.userActionService.storeTransientUserActionData(userActionId, model.comment, model.docIds, model.effectiveDate, model.processActionWorkflowBlockId);
                //Randy - end transient user action data preservation for validation error
                var promise = this.usePostHandler(params);
                promise.then(function (manageAppDto) { return self.displayDocumentsAndDownloads(manageAppDto); });
                return promise;
            };
            ProcessService.prototype.displayDocumentsAndDownloads = function (manageAppDto) {
                this.downloadDocuments(manageAppDto);
                this.showGrowlMessages(manageAppDto);
            };
            ProcessService.prototype.showGrowlMessages = function (processDto) {
                var _this = this;
                var clearUserActionTransientData = true;
                if (processDto.successMessages && processDto.successMessages.length > 0) {
                    processDto.successMessages.forEach(function (message) { return _this.growl.success(message); });
                }
                if (processDto.infoMessages && processDto.infoMessages.length > 0) {
                    processDto.infoMessages.forEach(function (message) { return _this.growl.info(message); });
                }
                if (processDto.warnMessages && processDto.warnMessages.length > 0) {
                    processDto.warnMessages.forEach(function (message) { return _this.growl.warning(message); });
                }
                if (processDto.errorMessages && processDto.errorMessages.length > 0) {
                    clearUserActionTransientData = false;
                    processDto.errorMessages.forEach(function (message) { return _this.growl.error(message); });
                }
                if (processDto.invalidEffectiveDate) {
                    clearUserActionTransientData = false;
                    if (processDto.effectiveDateErrorMessage) {
                        this.growl.error(processDto.effectiveDateErrorMessage);
                    }
                    else {
                        var dateString = processDto.lastStateEffectiveDate;
                        var lastStateDate = new Date(dateString);
                        if (processDto.showTimeForInvalidEffective) {
                            this.growl.error("This action cannot be set before the most recent state/status: " +
                                lastStateDate.toLocaleDateString() +
                                " - " +
                                lastStateDate.toLocaleTimeString());
                        }
                        else {
                            this.growl.error("This action cannot be set before the most recent state/status: " + lastStateDate.toLocaleDateString());
                        }
                    }
                }
                //Randy - transient user action data preservation for validation error
                if (clearUserActionTransientData) {
                    this.userActionService.clearTransientUserActionData();
                }
                //Randy - end transient user action data preservation for validation error
            };
            ProcessService.prototype.downloadDocuments = function (manageProcessDto) {
                if (manageProcessDto.documentsToDownload && manageProcessDto.documentsToDownload.length > 0) {
                    for (var index = 0; index < manageProcessDto.documentsToDownload.length; index++) {
                        window.open("./api/document/" + manageProcessDto.documentsToDownload[index]);
                    }
                }
                //        
            };
            ProcessService.prototype.deleteAssignment = function (processId, assignmentId) {
                var _this = this;
                var d = this.$q.defer();
                this.$http.post("./api/Process/" + processId + "/DeleteAssignment/" + assignmentId, null)
                    .then(function (r) {
                    var result = r.data;
                    if (result.process) {
                        _this.$rootScope.$broadcast('ProcessChanged', result.process);
                    }
                    else {
                        d.resolve();
                    }
                });
                return d.promise;
            };
            ProcessService.prototype.addAssignment = function (processId, newAssignment) {
                var _this = this;
                var d = this.$q.defer();
                this.$http.post("./api/Process/" + processId + "/AddAssignment/", newAssignment)
                    .then(function (r) {
                    var result = r.data;
                    if (result.process) {
                        _this.$rootScope.$broadcast('ProcessChanged', result.process);
                    }
                    else {
                        d.resolve(result.assignment);
                    }
                });
                return d.promise;
            };
            ProcessService.prototype.removeReview = function (processId, reviewSetId, reviewId) {
                var d = this.$q.defer();
                this.$http.post('./api/Process/' +
                    processId +
                    "/ReviewSet/" +
                    reviewSetId +
                    "/Review/" +
                    reviewId +
                    '/Remove', null)
                    .then(function (r) {
                    d.resolve(r);
                });
                return d.promise;
            };
            ProcessService.prototype.addProcessEvent = function (processId, model) {
                var params = model;
                this.handlerUrl = "api/Process/" + processId + "/AddProcessEvent";
                return this.usePostHandler(params);
            };
            ProcessService.prototype.isFieldUpdatable = function (process, processConfig, form, field) {
                // Ensure Form is in Visible Container
                if (!this.isFormInVisibleContainer(process, processConfig, form))
                    return false;
                // Ensure Form is Updatable or Readonly (Readonly forms can have Field level security overrides to make certain fields updatable)
                if (!process.formsVisibilities ||
                    !process.formsVisibilities[form.uniqueIdentifier] ||
                    (process.formsVisibilities[form.uniqueIdentifier].formVisiblility !== 2 /* Updateable */ &&
                        process.formsVisibilities[form.uniqueIdentifier].formVisiblility !== 1 /* ReadOnly */)) {
                    return false;
                }
                var formVisibility = process.formsVisibilities[form.uniqueIdentifier];
                var formSection = field.myFormSection;
                var formStep = Enumerable.from(form.mySteps).single(function (i) { return i.id == formSection.formStep_id; });
                // Ensure Form Step is Visible
                if (formVisibility.hiddenSteps && formVisibility.hiddenSteps.indexOf(formStep.id) !== -1) {
                    return false;
                }
                // Ensure Form Section is Visible
                if (formVisibility.hiddenGroups && formVisibility.hiddenGroups.indexOf(formSection.objectSchema.uniqueIdentifier) !== -1) {
                    return false;
                }
                // Ensure Field is Updatable - A Field that is not in the fieldsVisiblity dictionary has no security restrictions
                var inFieldsVisibility = formVisibility.fieldsVisiblity &&
                    formVisibility.fieldsVisiblity[field.schemaProperty.uniqueIdentifier];
                if (inFieldsVisibility && formVisibility.fieldsVisiblity[field.schemaProperty.uniqueIdentifier] !== 2 /* Updateable */) {
                    return false;
                }
                // If not defined explicitly for the field then use the form visibility
                if (!inFieldsVisibility && process.formsVisibilities[form.uniqueIdentifier].formVisiblility !== 2 /* Updateable */) {
                    return false;
                }
                // Now check the display conditions
                var pertinentConditionIds = [];
                if (field.condition_id) {
                    pertinentConditionIds.push(field.condition_id);
                }
                if (formSection.condition_id) {
                    pertinentConditionIds.push(formSection.condition_id);
                }
                if (formStep.condition_id) {
                    pertinentConditionIds.push(formSection.condition_id);
                }
                for (var i = 0; i < pertinentConditionIds.length; i++) {
                    if (process.conditionStates &&
                        process.conditionStates.hasOwnProperty(pertinentConditionIds[i]) &&
                        !process.conditionStates[pertinentConditionIds[i]]) {
                        return false;
                    }
                }
                // Now check readonly conditions
                var pertinentReadonlyConditionIds = [];
                if (field.readonlyCondition_id) {
                    pertinentReadonlyConditionIds.push(field.readonlyCondition_id);
                }
                if (formSection.readonlyCondition_id) {
                    pertinentReadonlyConditionIds.push(formSection.readonlyCondition_id);
                }
                for (var i = 0; i < pertinentReadonlyConditionIds.length; i++) {
                    if (process.conditionStates &&
                        process.conditionStates.hasOwnProperty(pertinentReadonlyConditionIds[i]) &&
                        process.conditionStates[pertinentReadonlyConditionIds[i]]) {
                        return false;
                    }
                }
                return true;
            };
            ProcessService.prototype.isFormInVisibleContainer = function (process, processConfig, form) {
                for (var i = 0; i < processConfig.myFormContainers.length; i++) {
                    var currentFormContainer = processConfig.myFormContainers[i];
                    if (process.containersVisibilities[currentFormContainer.uniqueIdentifier]) {
                        var formIdsInContainer = Enumerable.from(currentFormContainer.containerItems).select(function (i) { return i.form_id; }).toArray();
                        if (formIdsInContainer.indexOf(form.id) !== -1) {
                            return true;
                        }
                    }
                }
                return false;
            };
            ProcessService.prototype.processFormUpdateResults = function (process, updatedFields, conditionService, impactedConditionStates) {
                for (var i = 0; i < updatedFields.length; i++) {
                    this.updateFormWithFieldUpdateResult(process, updatedFields[i]);
                }
                if (impactedConditionStates) {
                    for (var propName in impactedConditionStates) {
                        if (impactedConditionStates.hasOwnProperty(propName)) {
                            process.conditionStates[propName] = impactedConditionStates[propName];
                        }
                    }
                }
                else {
                    // Need to call the server if any conditions are dependent on the updated fields
                    var updatedFieldIds = Enumerable.from(updatedFields).select(function (i) { return i.fieldUniqueId; }).toArray();
                    var conditionsToExecute = [];
                    if (process.propertyConditionDependencies) {
                        for (var i = 0; i < updatedFields.length; i++) {
                            if (process.propertyConditionDependencies[updatedFields[i].fieldUniqueId] &&
                                process.propertyConditionDependencies[updatedFields[i].fieldUniqueId].conditions &&
                                process.propertyConditionDependencies[updatedFields[i].fieldUniqueId].conditions.length > 0) {
                                conditionsToExecute.addRange(process.propertyConditionDependencies[updatedFields[i].fieldUniqueId].conditions);
                            }
                        }
                    }
                    if (conditionsToExecute.length > 0) {
                        conditionsToExecute = Enumerable.from(conditionsToExecute).distinct().toArray();
                        conditionService.executeConditions(process.id, conditionsToExecute).then(function (conditionResults) {
                            for (var i = 0; i < conditionResults.length; i++) {
                                var result = conditionResults[i];
                                process.conditionStates[result.conditionId] = result.conditionPassed;
                            }
                        });
                    }
                }
            };
            ProcessService.prototype.updateFormWithFieldUpdateResult = function (process, result) {
                if (process.formJson[result.formUniqueId] &&
                    process.formJson[result.formUniqueId][result.formDataId]) {
                    if (result.listUniqueId === this.NO_VALUE_ID) {
                        if (process.formJson[result.formUniqueId][result.formDataId][result.fieldUniqueId] != result.value) {
                            process.formJson[result.formUniqueId][result.formDataId][result.fieldUniqueId] = result.value;
                        }
                    }
                    else {
                        // Dealing with a list update
                        var listObject = process.formJson[result.formUniqueId][result.formDataId][result.listUniqueId];
                        if (!listObject) {
                            listObject = [{ id: result.rowId }];
                            process.formJson[result.formUniqueId][result.formDataId][result.listUniqueId] = listObject;
                        }
                        var row = undefined;
                        for (var i = 0; i < listObject.length; i++) {
                            var currentRow = listObject[i];
                            if (currentRow.id === result.rowId) {
                                row = currentRow;
                                break;
                            }
                        }
                        if (!row) {
                            row = { id: result.rowId };
                            listObject.push(row);
                        }
                        if (!row[result.fieldUniqueId] || row[result.fieldUniqueId] != result.value) {
                            row[result.fieldUniqueId] = result.value;
                        }
                    }
                }
            };
            return ProcessService;
        }(services.HttpHandlerService));
        services.ProcessService = ProcessService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("ProcessService", ["$q", "$http", "$rootScope", "growl", "userActionService", "ModalService"]);
